"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiOrderContractorDto = void 0;
const billing_core_order_contractor_role_enum_1 = require("../../../../billing-core/billing-core-order/types/enums/billing-core-order-contractor-role.enum");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let BillingApiOrderContractorDto = class BillingApiOrderContractorDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Роль контрагента в сделке",
  enum: billing_core_order_contractor_role_enum_1.BillingCoreOrderContractorRoleEnum
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEnum)(billing_core_order_contractor_role_enum_1.BillingCoreOrderContractorRoleEnum), __metadata("design:type", String)], BillingApiOrderContractorDto.prototype, "role", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id контрагента - участника сделки",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiOrderContractorDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Если роль = комиссионер, то его комиссия от взаиморасчетов продавца и покупателя;
    указывается в процентах.`,
  type: String,
  format: "decimal",
  example: "50",
  required: false,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDecimal)({
  decimal_digits: "1,"
}), __metadata("design:type", Object)], BillingApiOrderContractorDto.prototype, "fee", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Id счёта используемого контрагентом в сделке (не обязательно).
    Значение может быть автоматически добавлено в процессе первой оплаты и выбора счетов
    на основе используемого мерчант-провайдера.`,
  format: "uuid",
  type: String,
  required: false,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiOrderContractorDto.prototype, "accountId", void 0);
BillingApiOrderContractorDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiOrderContractorDto);
exports.BillingApiOrderContractorDto = BillingApiOrderContractorDto;
